import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { buildParamsGTM, sendEventGTM } from '@/services/googleTagManager'
import { gtmEvents } from '@/shared/consts/gtmEvents'
import { useNavigationGuard } from '../NavigationGuard/useNavigationGuard'
import { useUserStore } from '@/store/useUserStore'
import { useScheduleStore } from '@/store/useScheduleStore'

export function NavigationEvents() {
  const [searchParams] = useSearchParams()
  const user = useUserStore((e) => e.user)
  const userId = user?.id

  const { nextStep, pathIncludedInSteps, pathName } = useNavigationGuard()

  const location = useScheduleStore((e) => e.location)
  const healthCarrier = useScheduleStore((e) => e.healthCarrier)
  const healthPlan = useScheduleStore((e) => e.healthPlan)
  const product = useScheduleStore((e) => e.product)
  const patient = useScheduleStore((e) => e.patient)

  const mapGender = (gender?: string) => {
    if (gender === 'F') return 'feminino'
    if (gender === 'M') return 'masculino'
    if (gender) return 'outro'
    return ''
  }

  useEffect(() => {
    if (pathName !== nextStep && pathIncludedInSteps) {
      return
    }

    if (pathName.includes('fallback')) {
      sendEventGTM(gtmEvents.SHOW_FALLBACK, {
        action: pathName.split('/').at(-1),
        virtualPagePath: pathName,
        tipoFallback: 'consulta',
        unidade: location?.name ?? '',
        convenio: healthCarrier?.name ?? '',
        plano: healthPlan?.name ?? '',
        especialidade: product?.name ?? '',
        tipoExame: '',
        sexoBiologico: mapGender(patient?.gender)
      })
    }

    sendEventGTM(gtmEvents.PAGE_VIEW, {
      ...buildParamsGTM(searchParams),
      virtualPageView: pathName,
      userId
    })
  }, [
    pathName,
    searchParams,
    userId,
    pathIncludedInSteps,
    nextStep,
    location?.name,
    healthCarrier?.name,
    healthPlan?.name,
    product?.name,
    patient?.gender
  ])

  return null
}
